export interface AmplitudeEvents {
  // When a user applies filters to find workouts
  workout_filtered: {
    filters_applied: Record<string, any>;
    results_count: number;
  };

  // When a user changes a movement in a workout
  exercise_swapped: {
    workout_name: string;
    workout_id: string;
    exercise_from: string;
    exercise_to: string;
  };

  // When the whiteboard feature is activated
  whiteboard_opened: {
    workout_id: string;
    workout_name: string;
    is_presenter_view: boolean;
  };

  // When a user changes the language of the app
  language_changed: {
    from_lang: string;
    to_lang: string;
  };

  // When a resource file is viewed or downloaded
  resource_viewed: {
    resource_type: string;
    resource_id: string;
    resource_title: string;
  };
}

export type AmplitudeEventName = keyof AmplitudeEvents;

export type AvailableProperties<K extends AmplitudeEventName> = AmplitudeEvents[K];

export enum UserProperties {
  PREFERRED_LANGUAGE = 'preferredLanguage',
}
